import { FIXED_INDENTS } from 'vars/index'

type RowGapKey = 'SIZE_0' | 'SIZE_10'
export const InputBlockRowGaps: Record<RowGapKey, readonly [string]> = {
  SIZE_0: [FIXED_INDENTS.INDENT_0],
  SIZE_10: [FIXED_INDENTS.INDENT_10],
} as const
export type InputBlockRowGap =
  (typeof InputBlockRowGaps)[keyof typeof InputBlockRowGaps]

export const InputBlockMargins = {
  SIZE_10: [FIXED_INDENTS.INDENT_20, FIXED_INDENTS.INDENT_0],
}
export type InputBlockMargin =
  (typeof InputBlockMargins)[keyof typeof InputBlockMargins]
